import { get, post } from '@/utils/request'
/* 获取会员消费记录 */
export const getRecords = (data) => get('/records/consumption/findRecords', data)
/* 添加子账户 */
export const addSubAccount = (data) => post('/subAccount/add', data)
/* 获取子账户列表 */
export const getSubAccountList = (data) => get('/subAccount/list', data)
/* 获取关联的父账户列表 */
export const getParentAccountList = (data) => get('/subAccount/parentList', data)
/* 编辑子账户权限 */
export const editSubAccount = (data) => post('/subAccount/edit', data)
/* 删除子账户 */
export const deleteSubAccount = (data) => post('/subAccount/del', data)
/* 判断用户是否是会员管理员 */
export const isMemberAdmin = (data) => get('/subAccount/isAdmin', data)
/* 判断用户是否是会员 */
export const isMember = (data) => get('/subAccount/isMember', data)
/* 根据手机号获取会员信息 */
export const getMemberByPhone = memberPhone => get(`/Member/getMemberByPhone/${memberPhone}`)
/* 是否有查看测试数据的权限 */
export const hasTestDataRight = memberPhone => get(`/Member/hasTestDataRight/${memberPhone}`)
/* 发短信 */
export const sendPhoneMessage = (data) => post(`/Member/sendPhoneMessage`,data)
/* 同意子账号申请 */
export const auditSubAccountApply = (data) => post(`/subAccount/auditSubAccountApply`,data)
/* 获取剩余申请次数 */
export const getRemainApplyCount =() => get(`/Member/getRemainApplyCount`)



// WEBPACK FOOTER //
// ./src/api/member.js